module.exports = __webpack_public_path__ + "img/profilotesti.6f2539e3.png";